import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(3599); // 59:59 in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="bg-bbq-urgency text-white py-3 px-4 sticky top-0 z-50 shadow-lg border-b border-red-900/50" data-id="element-174">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center sm:text-left text-sm sm:text-base font-medium" data-id="element-175">
        <div className="flex items-center gap-2 uppercase tracking-wider font-display text-red-100" data-id="element-176">
          <span className="w-2 h-2 rounded-full bg-red-400 animate-pulse" data-id="element-177"></span>
          ¡Oferta de última hora!
        </div>
        <div className="hidden sm:block text-red-300" data-id="element-178">|</div>
        <p className="text-gray-100" data-id="element-179">
          Consigue el regalo para Papá hoy mismo y recíbelo al instante.
        </p>
        <div className="flex items-center gap-2 bg-black/30 px-3 py-1 rounded-md font-display tracking-widest text-bbq-gold" data-id="element-180">
          <Clock size={16} className="text-bbq-gold" data-id="element-181" />
          {formatTime(timeLeft)}
        </div>
      </div>
    </div>;
}